module.exports = __webpack_public_path__ + "static/img/刘仁杰.8994516.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/st/刘仁杰.jpg
// module id = kZnk
// module chunks = 1